import { resolveRectangleColor } from '../../../utilis/helpers';
import 'twin.macro';

const InPerformanceBorderContainer = ({ shapeColor }) => {
  // shapeColor() carries the backend's `rectangleColor` — a numeric
  // rectangleFlag or a raw CSS string. No color to apply → transparent border.
  const color = resolveRectangleColor(shapeColor?.()) ?? 'transparent';

  return (
    <div
      style={{ borderColor: color }}
      tw="pointer-events-none absolute top-0 left-0 opacity-100 md:border-[8px] border-[4px] flex items-center justify-center h-full w-full z-[100]"
    >
      <div
        tw="pointer-events-none absolute top-0 left-0 md:border-[22px] border-[15px] opacity-30 flex items-center justify-center h-full w-full z-10"
        style={{ borderColor: color }}
      />
    </div>
  );
};
export default InPerformanceBorderContainer;
